module.exports = __webpack_public_path__ + "img/vvf.5c0a1567.webp";